export const createCustomAlarmDefinitionMutation = () => `
mutation createCustomAlarmDefinition($definition: CreateCustomAlarmDefinition!) {
    createCustomAlarmDefinition(definition: $definition)
}
`;

export const getRegisteredEventsQuery = () => `
query getRegisteredEvents($type: EntityType!, $id: UUID!) {
    registeredEvents(type: $type, id: $id) {
        id
        displayName
    }
}
`;

export const getCustomAlarmDefinitionByIdQuery = () => `
 query getCustomAlarmDefinitionById($id: UUID!) {
    customAlarmDefinition(id: $id) {
        id
        definedFromDomainType
        applicableToDomainType
        domainEntityId
        name
        eventsToTrack {
            id
            displayName
        }
        trackingTypeConfiguration {
            type
            windowDays
        }
        grayNotification {
            enabled
            numberOfEvents
        }
        yellowNotification {
            enabled
            numberOfEvents
        }
        redNotification {
            enabled
            numberOfEvents
        }
        isResettable
        requiresCommentOnReset
        active
    }
 }
`;

export const updateCustomAlarmDefinitionMutation = () => `
    mutation updateCustomAlarmDefinition($update: UpdateCustomAlarmDefinition!, $id: UUID!) {
        updateCustomAlarmDefinition(update: $update, id: $id)
    }
`;
